import validator from "./validator";

const urlParam = {
  getValidId: (value: string | number): number | null => {
    if (!validator.isPositiveInteger(value)) {
      return null;
    }
    return Number(value);
  },
};

/** URL 參數處理工具集：驗證並取出合法的正整數 id */
export default urlParam;
